import { render, staticRenderFns } from "./FoodDetail.vue?vue&type=template&id=5c3bceec&scoped=true"
import script from "./FoodDetail.vue?vue&type=script&lang=js"
export * from "./FoodDetail.vue?vue&type=script&lang=js"
import style0 from "./FoodDetail.vue?vue&type=style&index=0&id=5c3bceec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3bceec",
  null
  
)

export default component.exports